import i18n from 'modules/core/lib/i18n'

export const employmentTypes = (): { [key: number]: string } => ({
  0: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_employment_type.values.0'),
  1: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_employment_type.values.1'),
  2: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_employment_type.values.2'),
})

export const flatRateTaxes = (): { [key: number]: string } => ({
  0: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_flat_rate_tax.values.0'),
  1: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_flat_rate_tax.values.1'),
  2: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_flat_rate_tax.values.2'),
})

export const activityTypes = (): { [key: number]: string } => ({
  0: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.0'),
  1: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.1'),
  2: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.2'),
  3: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.3'),
  4: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.4'),
  5: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.5'),
  6: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.6'),
  7: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.7'),
  8: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.8'),
  9: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_activity_type.values.9'),
})

export const personalKeyGroups = (): { [key: number]: string } => ({
  0: i18n.t('contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.0'),
  101: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.101'
  ),
  102: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.102'
  ),
  103: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.103'
  ),
  104: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.104'
  ),
  105: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.105'
  ),
  106: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.106'
  ),
  107: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.107'
  ),
  108: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.108'
  ),
  109: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.109'
  ),
  110: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.110'
  ),
  111: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.111'
  ),
  112: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.112'
  ),
  113: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.113'
  ),
  114: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.114'
  ),
  116: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.116'
  ),
  118: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.118'
  ),
  119: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.119'
  ),
  120: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.120'
  ),
  121: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.121'
  ),
  122: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.122'
  ),
  123: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.123'
  ),
  124: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.124'
  ),
  127: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.127'
  ),
  140: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.140'
  ),
  141: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.141'
  ),
  142: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.142'
  ),
  143: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.143'
  ),
  144: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.144'
  ),
  149: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.149'
  ),
  150: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.150'
  ),
  190: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.190'
  ),
  900: i18n.t(
    'contract_versions.flows.fix.steps.legal_and_extras.de_personal_key_group_id.values.900'
  ),
})
